/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.6-6-gfde9e530-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateTicketRequest interface.
 */
export function instanceOfCreateTicketRequest(value) {
    return true;
}
export function CreateTicketRequestFromJSON(json) {
    return CreateTicketRequestFromJSONTyped(json, false);
}
export function CreateTicketRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'] == null ? undefined : json['username'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'targetId': json['target_id'] == null ? undefined : json['target_id'],
        'targetName': json['target_name'] == null ? undefined : json['target_name'],
        'expiry': json['expiry'] == null ? undefined : (new Date(json['expiry'])),
        'numberOfUses': json['number_of_uses'] == null ? undefined : json['number_of_uses'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}
export function CreateTicketRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
        'user_id': value['userId'],
        'target_id': value['targetId'],
        'target_name': value['targetName'],
        'expiry': value['expiry'] == null ? undefined : ((value['expiry']).toISOString()),
        'number_of_uses': value['numberOfUses'],
        'description': value['description'],
    };
}
